import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FormlyModule } from "@ngx-formly/core";
import { AlertModule } from "@vp/shared/components/alert";
import { FlexModule } from "@vp/shared/directives/flex";
import { SpinnerModule } from "@vp/shared/spinner";
import { AddOpinionFormComponent } from "./add-opinion-form/add-opinion-form.component";
import { AddServiceFormComponent } from "./add-service-form/add-service-form.component";
import { EditServiceCostComponent } from "./edit-service-cost/edit-service-cost.component";

@NgModule({
  declarations: [EditServiceCostComponent, AddOpinionFormComponent, AddServiceFormComponent],
  imports: [
    AlertModule,
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: "edit-service-cost",
          component: EditServiceCostComponent
        }
      ]
    }),
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    ReactiveFormsModule,
    SpinnerModule,
    FlexModule
  ]
})
export class FormlyEditServiceCostModule {}
